import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_7965e83a from 'nuxt_plugin_plugin_7965e83a' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_cfb862ea from 'nuxt_plugin_plugin_cfb862ea' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_gtm_8a2df6e2 from 'nuxt_plugin_gtm_8a2df6e2' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_axios_05cfb379 from 'nuxt_plugin_axios_05cfb379' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_distplugin2a2a31d4_f5abd900 from 'nuxt_plugin_distplugin2a2a31d4_f5abd900' // Source: ./dist.plugin.2a2a31d4.js (mode: 'all')
import nuxt_plugin_pluginutils_e032083c from 'nuxt_plugin_pluginutils_e032083c' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_2fcfcea6 from 'nuxt_plugin_pluginrouting_2fcfcea6' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_3d0659e2 from 'nuxt_plugin_pluginmain_3d0659e2' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_recaptcha_3ab3dd68 from 'nuxt_plugin_recaptcha_3ab3dd68' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_nuxtuseragent_4f1fdb02 from 'nuxt_plugin_nuxtuseragent_4f1fdb02' // Source: ./nuxt-user-agent.js (mode: 'all')
import nuxt_plugin_gsapModule_6d691d78 from 'nuxt_plugin_gsapModule_6d691d78' // Source: ./gsapModule.js (mode: 'all')
import nuxt_plugin_cookie_43d67db3 from 'nuxt_plugin_cookie_43d67db3' // Source: ../node_modules/@webplatform/frontkit/dist/plugins/cookie (mode: 'client')
import nuxt_plugin_devtools_27b25718 from 'nuxt_plugin_devtools_27b25718' // Source: ../node_modules/@webplatform/frontkit/dist/plugins/dev-tools (mode: 'client')
import nuxt_plugin_analytics_29a99c52 from 'nuxt_plugin_analytics_29a99c52' // Source: ../node_modules/@webplatform/frontkit/dist/plugins/analytics (mode: 'client')
import nuxt_plugin_cdnimage_48333e0c from 'nuxt_plugin_cdnimage_48333e0c' // Source: ../node_modules/@webplatform/frontkit/dist/plugins/cdn-image (mode: 'all')
import nuxt_plugin_i18n_a9cd15a6 from 'nuxt_plugin_i18n_a9cd15a6' // Source: ../node_modules/@webplatform/frontkit/dist/plugins/i18n (mode: 'all')
import nuxt_plugin_floatingvue_e6916164 from 'nuxt_plugin_floatingvue_e6916164' // Source: ../node_modules/@webplatform/frontkit/dist/plugins/floating-vue (mode: 'client')
import nuxt_plugin_persistutmqueryparams_f90b1f5c from 'nuxt_plugin_persistutmqueryparams_f90b1f5c' // Source: ../node_modules/@webplatform/frontkit/dist/plugins/persist-utm-query-params (mode: 'client')
import nuxt_plugin_trailingslashredirect_f4b786e4 from 'nuxt_plugin_trailingslashredirect_f4b786e4' // Source: ../node_modules/@webplatform/frontkit/dist/plugins/trailing-slash-redirect (mode: 'all')
import nuxt_plugin_asbisui_24b8af9b from 'nuxt_plugin_asbisui_24b8af9b' // Source: ../plugins/asbis-ui (mode: 'all')
import nuxt_plugin_lazyload_dec3cfaa from 'nuxt_plugin_lazyload_dec3cfaa' // Source: ../plugins/lazy-load (mode: 'client')
import nuxt_plugin_meta_2133d05d from 'nuxt_plugin_meta_2133d05d' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Prestigio solutions","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"},{"hid":"description","name":"description","content":""},{"name":"format-detection","content":"telephone=no"}],"link":[{"rel":"apple-touch-icon","href":"\u002Fjoinu-apple-touch-icon.png"},{"rel":"preconnect","href":"https:\u002F\u002Fcdn0.it4profit.com"}],"style":[],"script":[{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);}})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":""}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_7965e83a === 'function') {
    await nuxt_plugin_plugin_7965e83a(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_cfb862ea === 'function') {
    await nuxt_plugin_plugin_cfb862ea(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_8a2df6e2 === 'function') {
    await nuxt_plugin_gtm_8a2df6e2(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_05cfb379 === 'function') {
    await nuxt_plugin_axios_05cfb379(app.context, inject)
  }

  if (typeof nuxt_plugin_distplugin2a2a31d4_f5abd900 === 'function') {
    await nuxt_plugin_distplugin2a2a31d4_f5abd900(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_e032083c === 'function') {
    await nuxt_plugin_pluginutils_e032083c(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_2fcfcea6 === 'function') {
    await nuxt_plugin_pluginrouting_2fcfcea6(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_3d0659e2 === 'function') {
    await nuxt_plugin_pluginmain_3d0659e2(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_3ab3dd68 === 'function') {
    await nuxt_plugin_recaptcha_3ab3dd68(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtuseragent_4f1fdb02 === 'function') {
    await nuxt_plugin_nuxtuseragent_4f1fdb02(app.context, inject)
  }

  if (typeof nuxt_plugin_gsapModule_6d691d78 === 'function') {
    await nuxt_plugin_gsapModule_6d691d78(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_cookie_43d67db3 === 'function') {
    await nuxt_plugin_cookie_43d67db3(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_devtools_27b25718 === 'function') {
    await nuxt_plugin_devtools_27b25718(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_analytics_29a99c52 === 'function') {
    await nuxt_plugin_analytics_29a99c52(app.context, inject)
  }

  if (typeof nuxt_plugin_cdnimage_48333e0c === 'function') {
    await nuxt_plugin_cdnimage_48333e0c(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_a9cd15a6 === 'function') {
    await nuxt_plugin_i18n_a9cd15a6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_floatingvue_e6916164 === 'function') {
    await nuxt_plugin_floatingvue_e6916164(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_persistutmqueryparams_f90b1f5c === 'function') {
    await nuxt_plugin_persistutmqueryparams_f90b1f5c(app.context, inject)
  }

  if (typeof nuxt_plugin_trailingslashredirect_f4b786e4 === 'function') {
    await nuxt_plugin_trailingslashredirect_f4b786e4(app.context, inject)
  }

  if (typeof nuxt_plugin_asbisui_24b8af9b === 'function') {
    await nuxt_plugin_asbisui_24b8af9b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_lazyload_dec3cfaa === 'function') {
    await nuxt_plugin_lazyload_dec3cfaa(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_2133d05d === 'function') {
    await nuxt_plugin_meta_2133d05d(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
